import React from 'react';
import { Modal } from 'react-bootstrap';

const ClassSelectionModal = ({
  show,
  step,
  onHide,
  onConfirm,
  canConfirm,
  children,
}) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    dialogClassName="class-selection-modal"
    backdropClassName="class-selection-backdrop"
  >
    <Modal.Header closeButton>
      <Modal.Title>
        Step #2: Register Below For The <span>Free LIVE Event!</span>
      </Modal.Title>
    </Modal.Header>

    <Modal.Body>{children}</Modal.Body>

    <Modal.Footer className="class-modal-footer">
      {step !== 'select' ? (
        <p>
          By providing your contact information, you agree to receive marketing communications from
          Real Success LLC. Message and data rates may apply. You may opt out at any time.
        </p>
      ) : (
        <>
          <button
            type="button"
            className="class-modal-submit"
            onClick={onConfirm}
            disabled={!canConfirm}
          >
           Next →
          </button>
          <p>
            By providing your contact information, you agree to receive marketing communications from
            Real Success LLC. Message and data rates may apply. You may opt out at any time.
          </p>
        </>
      )}
    </Modal.Footer>
  </Modal>
);

export default ClassSelectionModal;
